import { RootState } from 'store';
import { IProvidersResponse } from 'types';

export const getProvidersSelector = (store: RootState): IProvidersResponse | null => store.providers.data || null;

export const getProvidersIsLoadingSelector = (store: RootState): boolean => store.providers.isLoading;
